module.exports = __webpack_public_path__ + "static/img/all_people.cca346f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/all_people.jpg
// module id = YRPS
// module chunks = 1